import React from 'react';

import {FormattedMessage, injectIntl} from 'react-intl';

class MarketplaceBillDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = props.formData || {
      className: 'CompanyBillDetails',
      address: {
        display: '',
      },
      contactDetails: {
        email: '',
        phoneNumber: '',
      },
    };

    this.onChange = this.onChange.bind(this);
    this.onClassNameChange = this.onClassNameChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps.formData);
  }

  onChange(name) {
    return (event) => {
      this.setState({
        [name]: event.target.value
      }, () => this.props.onChange(this.state));
    };
  }

  onClassNameChange() {
    const newBillDetails = this.state;

    if (this.state.className === 'CompanyBillDetails') {
      newBillDetails.className = 'PersonalBillDetails';
    } else {
      newBillDetails.className = 'CompanyBillDetails';
    }

    this.setState({
      billDetails: newBillDetails
    }, () => this.props.onChange(this.state));
  }

  onSubPropertyChange(property, subProperty) {
    return (event) => {
      const newBillDetails = this.state;
      newBillDetails[property][subProperty] = event.target.value;

      this.setState(newBillDetails, () => this.props.onChange(this.state));
    };
  }

  render() {
    const detailsFields = this.state.className === 'CompanyBillDetails'? (
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.company.name.label'}/>
            </label>
            <input type="text" value={ this.state.companyName } onChange={this.onChange("companyName")}
                   className="form-control" name="companyDetails"/>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.registry.code.label'}/>
            </label>
            <input type="text" value={ this.state.registryCode } onChange={this.onChange("registryCode")}
                   className="form-control" name="registryCode"/>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.vat.number.label'}/>
            </label>
            <div className="m-b-1">
              <input type="text" value={ this.state.vatNumber } onChange={this.onChange("vatNumber")}
                     className="form-control" name="vatNumber"/>
            </div>
            <p className="help-block">
              <FormattedMessage id={'bill.details.form.field.vat.number.help'}/>
            </p>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.iban.label'}/>
            </label>
            <input type="text" value={ this.state.iban } onChange={this.onChange("iban")}
                   className="form-control" name="iban"/>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.address.label'}/>
            </label>
            <input type="text" value={ this.state.address.display } onChange={this.onSubPropertyChange("address", "display")}
                   className="form-control" name="address"/>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.email.label'}/>
            </label>
            <input type="text" value={ this.state.contactDetails.email }
                   onChange={this.onSubPropertyChange("contactDetails", "email")}
                   className="form-control" name="email"/>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.phone.number.label'}/>
            </label>
            <input type="text" value={ this.state.contactDetails.phoneNumber }
                   onChange={this.onSubPropertyChange("contactDetails", "phoneNumber")}
                   className="form-control" name="phoneNumber"/>
          </div>
        </div>
      </div>
    ): (
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.full.name.label'}/>
            </label>
            <input type="text" value={ this.state.fullName } onChange={this.onChange("fullName")}
                   className="form-control" name="fullName"/>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.iban.label'}/>
            </label>
            <input type="text" value={ this.state.iban } onChange={this.onChange("iban")}
                   className="form-control" name="iban"/>
          </div>
        </div>
        <div className="col-12">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.address.label'}/>
            </label>
            <input type="text" value={ this.state.address.display } onChange={this.onSubPropertyChange("address", "display")}
                   className="form-control" name="address"/>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.email.label'}/>
            </label>
            <input type="text" value={ this.state.contactDetails.email }
                   onChange={this.onSubPropertyChange("contactDetails", "email")}
                   className="form-control" name="email"/>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="form-group">
            <label className="control-label">
              <FormattedMessage id={'bill.details.form.field.phone.number.label'}/>
            </label>
            <input type="text" value={ this.state.contactDetails.phoneNumber }
                   onChange={this.onSubPropertyChange("contactDetails", "phoneNumber")}
                   className="form-control" name="phoneNumber"/>
          </div>
        </div>
      </div>
    );

    return (
      <fieldset>
        <legend>
          <FormattedMessage id={'bill.details.form.field.legend'}/>
        </legend>
        <div className="form-group">
          <div className="checkbox">
            <label>
              <input type="checkbox"
                     checked={ this.state.className === 'CompanyBillDetails' }
                     onChange={ this.onClassNameChange }/> <FormattedMessage id={'bill.details.form.field.use.company.details.label'}/>
            </label>
          </div>
          <p className="help-block">
            <FormattedMessage id={'bill.details.form.field.use.company.details.help'}/>
          </p>
        </div>
        { detailsFields }
      </fieldset>
    );
  }
}

export default injectIntl(MarketplaceBillDetails);